import { render, staticRenderFns } from "./tournamentCard.vue?vue&type=template&id=2c8499b0&scoped=true&"
import script from "./tournamentCard.vue?vue&type=script&lang=js&"
export * from "./tournamentCard.vue?vue&type=script&lang=js&"
import style0 from "./tournamentCard.vue?vue&type=style&index=0&id=2c8499b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8499b0",
  null
  
)

export default component.exports